// 引入高德地图官方加载器
import AMapLoader from '@amap/amap-jsapi-loader';

// 定义需要加载的高德地图插件
const plugins = [
    "AMap.Geocoder",
    "AMap.PlaceSearch",
    "AMap.MouseTool",
    "AMap.CircleEditor",
    "AMap.PolygonEditor",
    "AMap.MarkerCluster",
    "AMap.GeometryUtil",
    "AMap.Scale",
    "AMap.ToolBar"
];

// 高德地图安全配置（添加这部分）
window._AMapSecurityConfig = {
    securityJsCode: '22bcde8ca7646ade9a7bd24def1e245f', // 你的安全校验码
};

// 高德地图插件配置
const AMapPlugin = {
    install(Vue) {
        Vue.prototype.$createAMap = function() {
            return new Promise((resolve, reject) => {
                AMapLoader.load({
                    key: "1aa0c76cc8b8c8ca765424a3cbe2789d", // 高德地图key
                    version: "2.0",
                    plugins: plugins,
                    AMapUI: {
                        version: "1.1",
                        plugins: ["misc/PathSimplifier"]
                    }
                }).then((AMap) => {
                    resolve(AMap);
                }).catch((error) => {
                    reject(error);
                    console.error("高德地图加载失败：", error);
                });
            });
        };
    }
};

export default AMapPlugin;